import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import type { PrimaryNavigationDestination } from "@-/dev.improve.haniverse.database.schemas.actor.schema._tables.user";
import { useCallback } from "react";

function useNavigator() {
  return useCallback(
    (destination: PrimaryNavigationDestination) => ({
      href: { pathname: `/(nav)/(app)/${destination}` as const },
      // Shell destinations load inside their own boundaries. Opening from Admin must stay
      // immediate even when a destination has no cached data or the device is offline.
      queries: [],
    }),
    [],
  );
}

export const useAdminPrimaryNavigationDestinationPageNavigator =
  createPageNavigator<PrimaryNavigationDestination>({
    useNavigator,
  });
